export default {
      id: "pdf-icon-usage",
      viewBox: "0 0 23 24",
      url: __webpack_public_path__ + "sprite.svg#pdf-icon",
      toString: function () {
        return this.url;
      }
    }